module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-47-8c69903bae0ff67a38c8563d2a459da1.svg";